"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoize = void 0;

var memoize = function memoize(fn, hashFn) {
  var cache = {};
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var address = hashFn ? hashFn.apply(this, args) : args[0];

    if (cache.hasOwnProperty(address)) {
      return cache[address];
    }

    var result = fn.apply(this, args);
    cache[address] = result;
    return result;
  };
};

exports.memoize = memoize;